import React from 'react';
import Helmet from 'react-helmet';
import { motion } from 'framer-motion';
import Nav from './Nav';

class Layout extends React.Component {
  render() {
    const { children } = this.props;

    return (
      <>
        <a href="#main-content" className="block h-0 active:h-full focus:h-full text-base" tabindex="0">
          Skip to main content
        </a>
        <div className="layout">
          <Helmet
            defaultTitle="Subscribe Pro"
            htmlAttributes={{
              lang: 'en',
            }}
          >
            <link rel="icon" type="image/png" href="/favicon-196x196.png" sizes="196x196" media="screen" />
            <link rel="icon" type="image/png" href="/favicon-96x96.png" sizes="96x96" media="screen" />
            <link rel="icon" type="image/png" href="/favicon-32x32.png" sizes="32x32" media="screen" />
            <link rel="icon" type="image/png" href="/favicon-16x16.png" sizes="16x16" media="screen" />
            <meta name="application-name" content="Subscribe Pro" />
            <meta name="msapplication-TileColor" content="#045B50" />

            <link rel="preconnect" href="https://fonts.googleapis.com" />
            <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin />
            <link
              href="https://fonts.googleapis.com/css2?family=DM+Mono:ital,wght@0,300;0,400;0,500;1,400&display=swap"
              rel="stylesheet preload prefetch"
              media="screen"
            />
          </Helmet>

          <Nav />
          <motion.main
            id="main-content"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{
              type: 'spring',
              mass: 0.55,
              stiffness: 70,
              duration: 0.3,
            }}
          >
            {children}
          </motion.main>
        </div>
      </>
    );
  }
}

export default Layout;
